<script setup lang="ts">
// 1:1 Port von club-offering/src/app/user/components/login-status.
//
// Angular rendert das Element IMMER und laesst es leer, wenn kein Haupt-User da ist; das CSS
// blendet es dann per `kgr-login-status:empty { display: none }` aus. Der Gast hat nie einen
// mainUser (`userId: null` im JWT), dieser Block erscheint also ausschliesslich nach einem
// echten Member-Login.
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { ensureClubCredentials } from '../../composables/useGuestAuth';
import { useUserStore } from '@shared/stores/user';

const router = useRouter();
const userStore = useUserStore();

const user = computed(() => userStore.currentUser);

/**
 * Angular: logout() → danach SOFORT wieder als anonymer Gast einloggen und auf `/:clubId`
 * navigieren. Ohne das zweite Login haette die App nach dem Logout gar keine Credentials mehr
 * und der Guard muesste sie auf der Zielroute neu holen.
 */
async function logout() {
    const clubId = userStore.institutionId;
    // `await` ist nicht kosmetisch: `logout()` loescht Token und institutionId ERST nach
    // `await Promise.all(callbacks)`. Ohne das Warten saehe ensureClubCredentials() noch den alten
    // Member-Token mit passender institutionId und uebersprnge das Holen des Gast-Tokens.
    // Angular erzwingt dieselbe Reihenfolge ueber die verschachtelte subscribe-Kette.
    await userStore.logout();
    if (clubId !== null) {
        await ensureClubCredentials(clubId);
        await router.push(`/${router.currentRoute.value.params.locale as string}/${clubId}`);
    }
}
</script>

<template>
    <div class="loginStatus">
        <div
            v-if="user"
            class="kgr-alert kgr-alert--info"
        >
            <!-- Bewusst KEIN v-html: der Key traegt kein Markup, und `fullName` ist ein
                 nutzerkontrollierter Anzeigename. Angular rendert ihn per {{ }} auto-escaped. -->
            {{ $t('Eingeloggt als {fullName}.', { fullName: user.fullName }) }}
            <!-- Angulars Template traegt hier ein Zero-Width-Space zwischen Text und Button. -->
            <!-- eslint-disable-next-line no-irregular-whitespace -->
            {{ '​' }}
            <button
                class="kgr-link"
                @click="logout"
            >
                {{ $t('Logout') }}
            </button>
        </div>
    </div>
</template>

<style scoped>
/* Angular: :host { display: block } plus `kgr-login-status:empty { display: none }` aus der
   App-Shell — in Vue rendert der Wrapper immer, also uebernimmt :empty dieselbe Rolle. */
.loginStatus {
    display: block;
}

.loginStatus:empty {
    display: none;
}
</style>
